module.exports = __webpack_public_path__ + "img/patients.e5a42e5c.svg";